export const getLocalDateString = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

export const initialRegistro = () => ({
  nombre: "",
  apellidos: "",
  documento: "",
  telefono: "",
  email: "",
  fuente_origen: "",
  empresa: "",
  nuevaEmpresa: { nombre: "" },
  entrada: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
  salida: "",
  observacion: "",
  transferido: false,
  convertido_a_prematricula: false,
  referido_por_id: null,
  fecha_visita_override: "",
});

export const normalizeInteresados = (lista) => {
  const limpiarTexto = (valor) => (typeof valor === "string" ? valor.trim() : valor || "");

  return (Array.isArray(lista) ? lista : []).map((item) => {
    const nombreOriginal = limpiarTexto(item.nombre);
    let nombres = limpiarTexto(item.nombres);
    let apellidos = limpiarTexto(item.apellidos || item.apellido);
    const partesNombre = nombreOriginal ? nombreOriginal.split(/\s+/).filter(Boolean) : [];

    if (!nombres && partesNombre.length) {
      if (partesNombre.length === 1) {
        nombres = partesNombre[0];
      } else {
        nombres = partesNombre.slice(0, partesNombre.length - 1).join(" ");
      }
    } else if (!nombres && nombreOriginal) {
      nombres = nombreOriginal;
    }

    if (!apellidos && partesNombre.length > 1) {
      apellidos = partesNombre.slice(-1).join(" ");
    }

    const nombreCompleto = [nombres, apellidos].filter(Boolean).join(" ").trim();
    return {
      ...item,
      nombres,
      apellidos,
      nombre: nombreCompleto || nombres || apellidos || "",
      documento: item.documento || item.documento_identidad || "",
      telefono: item.telefono || item.celular || "",
      email: item.email || "",
      fuente_origen: item.fuente_origen || item.fuente_origen_nombre || item.fuente_nombre || "",
      empresa:
        item.empresa ||
        item.empresa_referencia ||
        item.empresa_origen ||
        item.empresa_nombre ||
        item.empresa_referencia_nombre ||
        item.centro ||
        item.centro_referencia ||
        "",
      centro: item.centro || item.centro_referencia || "",
      referido_por_id: item.referido_por_id || null,
      referido_nombres: item.referido_nombres || "",
      referido_apellidos: item.referido_apellidos || "",
      referido_documento: item.referido_documento || "",
      referido_estado: item.referido_estado || item.referido_tipo || item.referido_estado_formacion || "",
    };
  });
};

export const obtenerNombreFormulario = (registro) => {
  if (!registro) {
    return { nombres: "", apellidos: "" };
  }
  const limpiar = (valor) => (typeof valor === "string" ? valor.trim() : valor ? String(valor) : "");
  let nombres = limpiar(registro.nombres || registro.nombre);
  let apellidos = limpiar(registro.apellidos || registro.apellido);
  const nombreEvaluado = limpiar(registro.nombre || registro.nombres || `${nombres} ${apellidos}`.trim());
  if ((!nombres || nombres === nombreEvaluado) && nombreEvaluado) {
    const partes = nombreEvaluado.split(/\s+/).filter(Boolean);
    if (partes.length > 1) {
      nombres = partes.slice(0, partes.length - 1).join(" ");
      if (!apellidos) {
        apellidos = partes.slice(-1).join(" ");
      }
    }
  }
  if (!apellidos && nombreEvaluado) {
    const partes = nombreEvaluado.split(/\s+/).filter(Boolean);
    if (partes.length > 1) {
      apellidos = partes.slice(-1).join(" ");
      if (!nombres) {
        nombres = partes.slice(0, partes.length - 1).join(" ");
      }
    }
  }
  return { nombres: nombres || "", apellidos: apellidos || "" };
};

export const toMysqlDateTime = (value) => {
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value.trim())) {
    return value.trim();
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const pad = (n) => String(n).padStart(2, "0");
  return [
    date.getFullYear(),
    "-",
    pad(date.getMonth() + 1),
    "-",
    pad(date.getDate()),
    " ",
    pad(date.getHours()),
    ":",
    pad(date.getMinutes()),
    ":",
    pad(date.getSeconds()),
  ].join("");
};

export const toDateInputFormat = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date.toISOString().slice(0, 10);
};

export const toTimeDisplay = (value) => {
  if (!value) return "";
  const date =
    value instanceof Date ? value : new Date(typeof value === "string" ? value.replace(" ", "T") : value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

export const getSortTimestamp = (value) => {
  if (!value) return 0;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

export const buildBitacoraRows = (visitas, toDateInputFormatFn = toDateInputFormat) => {
  if (!Array.isArray(visitas) || !visitas.length) return [];
  return visitas.map((v) => ({
    id: v.id,
    interesado_id: v.interesado_id,
    estado_interes: v.estado_interes || "",
    referido_por_id: v.referido_por_id || null,
    referido_nombres: v.referido_nombres || "",
    referido_apellidos: v.referido_apellidos || "",
    referido_documento: v.referido_documento || "",
    referido_estado: v.referido_estado || "",
    fecha_visita: v.fecha_visita || null,
    fecha_fin_visita: v.fecha_fin_visita || null,
    fecha_visita_iso: toDateInputFormatFn(v.fecha_visita) || null,
    entrada: v.fecha_visita ? toTimeDisplay(v.fecha_visita) : "",
    salida: v.fecha_fin_visita ? toTimeDisplay(v.fecha_fin_visita) : "",
    observacion: v.observacion || "",
    novedad: v.novedad || "",
    transferido: !!v.transferido,
    convertido_a_prematricula: !!v.convertido_a_prematricula,
  }));
};
